module.exports = __webpack_public_path__ + "static/salesforce-booth-b7c02e3318ee409677dbb0d1304f3ed1.jpg";